// extracted by mini-css-extract-plugin
export default {"formContainer":"MedicsDetail_formContainer__pL38W","inputs":"MedicsDetail_inputs__rShHP","btnEdit":"MedicsDetail_btnEdit__WyQ36","endBtn":"MedicsDetail_endBtn__ON8lt"};